var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-tooltip',{attrs:{"bottom":""},scopedSlots:_vm._u([{key:"activator",fn:function(ref){
var on = ref.on;
var attrs = ref.attrs;
return [_c('v-btn',_vm._g(_vm._b({attrs:{"id":"download-json-btn","icon":"","x-large":"","color":"primary"},on:{"click":_vm.downloadJson}},'v-btn',attrs,false),on),[_c('v-icon',[_vm._v("fab fa-js")])],1)]}}])},[_vm._v(" Export to JSON ")])}
var staticRenderFns = []

export { render, staticRenderFns }